import GlassCard from "../components/GlassCard";

const About = () => {
  return (
    <div className="max-w-3xl mx-auto px-4 py-10 text-white">
      <GlassCard>
        <h2 className="text-4xl font-extrabold mb-6 text-center tracking-wide">
          About Me
        </h2>

        <p className="text-gray-300 text-lg leading-relaxed">
          <span className="block mb-4">
            👋 I'm <strong className="text-cyan-400">Vinodh Kumar R</strong>, a{" "}
            <strong>Cloud Security & Generative AI Engineer at Deloitte</strong>{" "}
            with <strong>1.5+ years of experience</strong> in building secure and
            scalable cloud-native systems across{" "}
            <strong>AWS and Google Cloud Platform (GCP)</strong>.
          </span>

          <span className="block mb-4">
            🛡️ My expertise lies in <strong>Cloud Security Engineering</strong>,{" "}
            <strong>DevSecOps automation</strong>, and{" "}
            <strong>security posture management</strong>. I work extensively
            with tools like <strong>Prisma Cloud</strong>,{" "}
            <strong>AWS Security services</strong>, and{" "}
            <strong>Infrastructure as Code using Terraform</strong> to secure
            modern cloud environments.
          </span>

          <span className="block mb-4">
            🤖 I also design <strong>AI-powered security solutions</strong>{" "}
            using <strong>AWS Bedrock, Knowledge Bases, Amazon Lex</strong> and{" "}
            <strong>Retrieval-Augmented Generation (RAG)</strong> to build
            intelligent systems that provide contextual insights into assets,
            vulnerabilities, and security operations.
          </span>

          <span className="block mb-4">
            ☁️ I am an <strong>AWS Certified Machine Learning – Specialty</strong>{" "}
            professional passionate about combining{" "}
            <strong>cloud security, automation, and Generative AI</strong> to
            build resilient and intelligent cloud platforms.
          </span>

          <span className="block">
            🎓 Beyond engineering, I enjoy mentoring students, delivering
            technical sessions, and helping aspiring developers prepare for
            careers in cloud, cybersecurity, and software engineering.
          </span>
        </p>
      </GlassCard>
    </div>
  );
};

export default About;